import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/components/app/app.component';
import { appConfig } from './app/app.config';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';
import { UtilService } from '@jms/utils/util.services';

import { LicenseManager, provideGlobalGridOptions } from 'ag-grid-enterprise';

// Side-effect import: registers every entity manifest (workbuddy/entities) before first resolve.
import '@workbuddy/entities/entity.manifests';

navigator.serviceWorker.register('/download-zip/files.zip.worker.js', { scope: '/download-zip/' });

// Cross-tab logout: redirect if auth_token removed in another tab.
// Always carry returnUrl (+ SSO hint) so id login sends the user back to this tenant tab,
// not a bare id.workbuddy.* account session.
window.addEventListener('storage', (e) => {

    if (e.key === 'auth_token' && !e.newValue) {
        const env = ConfigService.environment;
        UtilService.navigate(env.jms.logoutHref, window.location.href, UtilService.ssoHintParams(env.sso));
    }
});

LicenseManager.setLicenseKey(ConfigService?.environment?.grid);
provideGlobalGridOptions({ theme: "legacy" });

if (ConfigService.environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig);
